import { useEffect, useState } from "react";

import { AdminShell } from "@/components/admin/admin-shell";
import { CategoryManager } from "@/components/admin/category-manager";
import { apiGet } from "@/services/api";
import type { Category } from "@/types/prisma";

/** `app/admin/categories/page.tsx`. */
export function AdminCategoriesPage() {
  const [categories, setCategories] = useState<Category[]>([]);

  useEffect(() => {
    let active = true;
    void apiGet<{ categories: Category[] }>("/api/admin/categories").then((data) => {
      if (active) setCategories(data?.categories ?? []);
    });
    return () => {
      active = false;
    };
  }, []);

  return (
    <AdminShell title="Categories">
      <CategoryManager initialCategories={categories} />
    </AdminShell>
  );
}
